<template>
  <a
    @click.stop="click"
    class="order_link--default"
    :class="cls"
  >
    <span>
      <slot></slot>
    </span>
  </a>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true }
  },
  data () {
    return {
      status: ''
    }
  },
  created () {
    const { query } = this.$route
    if (query.order === this.name) {
      this.status = query.orderType === 'asc' ? 'asc' : 'desc'
    }
  },
  computed: {
    cls () {
      if (this.status) {
        return this.status === 'asc' ? 'order-link--down' : 'order-link--up'
      }
      return ''
    }
  },
  methods: {
    click (e) {
      let { name, query } = this.$route
      query = {
        ...query,
        order: this.name,
        orderType: this.status === 'asc' ? 'desc' : 'asc'
      }
      this.$router.replace({ name, query })
    }
  }
}
</script>
